import React from 'react';
import QCXAlert from './QCXAlert';

export default function QCXErrorAlert(props) {
  return (
    <QCXAlert
      {...props}
      severity="error"
    />
  );
}
